import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Gesture from '@/util/Gesture.js';
import {clamp} from '@/util/bounds.js';
import { findUpTagByType } from '@/util/findUpTag.js'

// { setSize }
import actions from '@/action/panZoom.js';





// const actions = {};



const WHEEL_ZOOM_SENSITIVITY = 0.03


let events = [];
let gestureEvents = [];

// feature detect - in this case not dangerous, as pointer is not exclusively touch
if ((global.PointerEvent)||global.navigator && (global.navigator.pointerEnabled || global.navigator.msPointerEnabled)) {
    events = ['pointerover', 'pointerdown', 'pointermove', 'pointerup', 'pointerout', 'pointercancel',
              'MSPointerOver', 'MSPointerDown', 'MSPointerMove', 'MSPointerUp', 'MSPointerOut', 'MSPointerCancel', 'dragstart'];
} else {
    events = [  'focus', 'blur',
                'mouseover','mousedown', 'mousemove', 'mouseup', 'mouseout',
                'touchstart', 'touchmove', 'touchend', 'touchcancel'
            ];
}
if (global.GestureEvent && !global.TouchEvent) {
    gestureEvents = ['gesturestart', 'gesturechange', 'gestureend'];
}



/** PlatformEventInterface component description */
class PlatformEventInterface extends Component {
    constructor(props) {
        super(props);

        this.domRef = React.createRef();

        this.eventTarget = this.props.eventTarget;

        let self = this;
        this.updateDimensions = this.updateDimensions.bind(this);

        this.preventDefault = this.preventDefault.bind(this);

        this.handleMouseWheel = this.handleMouseWheel.bind(this);


        this.handleTouchUpdate = this.handleTouchUpdate.bind(this);
        this.handlePointerDown = this.handlePointerDown.bind(this);
        this.handlePointerUp = this.handlePointerUp.bind(this);
        this.handlePointerMove = this.handlePointerMove.bind(this);
        this.handlePointerCancel = this.handlePointerCancel.bind(this);

        this.handleRightClick = this.handleRightClick.bind(this);

        this.activeGesture = null;

        // this.timeout = 0;
        // this.handleTouchUpdate_throttled = function (e) {
        //     if (self.timeout) {
        //         // console.log('cancel', self.timeout);
        //         cancelAnimationFrame(self.timeout);
        //         self.timeout = null;
        //     }
        //     self.timeout = requestAnimationFrame(function(){
        //         self.handleTouchUpdate(e)
        //     });
        //     // console.log('new', self.timeout);
        // }.bind(this);

    }

    /**
     * Ok componentDidMount desc
     */
    componentDidMount() {
        console.log('PEI MOUNT');
        global.addEventListener("gesturestart", this.preventDefault, { useCapture: true, passive: false });
        global.addEventListener("gesturechange", this.preventDefault, { useCapture: true, passive: false });
        global.addEventListener("gestureend", this.preventDefault, { useCapture: true, passive: false });

        global.addEventListener("resize", this.updateDimensions);
        global.addEventListener('orientationchange', this.updateDimensions);
        // global.addEventListener('contextmenu', this.handleRightClick, false);

        for (var i=0, l=events.length; i<l; i++) {
            const event = events[i];

            // console.log('setup', event);

            let source;
            let handler = this.handleTouchUpdate;

            // if ((event == 'pointermove') 
            //     || (event == 'mousemove')
            //     || (event== 'touchmove')
            //     || (event == 'gesturechange')
            // ) {
                
            // }

            if ((event == 'pointerdown') 
                || (event == 'mousedown')
                || (event == 'touchstart')
                // || (event == 'gesturestart')
            ) {
                source = this.domRef.current.parentNode.parentNode;
                
            } else {
                source = global;
            }

            // console.log(event, 'SoURCE', source, handler);
            source.addEventListener(event, handler);
        }

        for (var i=0, l=gestureEvents.length; i<l; i++) {
            if ((gestureEvents[i] == 'pointermove') || (gestureEvents[i] == 'mousemove') || (gestureEvents[i] == 'touchmove') || (gestureEvents[i] == 'gesturechange')) {
                this.domRef.current.parentNode.addEventListener(gestureEvents[i], this.handleTouchUpdate, {  passive: true } ); //_throttled
            } else {
                this.domRef.current.parentNode.addEventListener(gestureEvents[i], this.handleTouchUpdate, { useCapture: true, passive: true } );
            }
        }

        this.domRef.current.parentNode.addEventListener('wheel', this.handleMouseWheel, {useCapture: true, passive: false});



        // this.domRef.current.parentNode.addEventListener('click', function(e) {
        //     console.log('click', e.target);
        // });

        this.updateDimensions();

        // 
    }

    componentWillUnmount() {
        console.log('PEI UNMOUNT');
        // const delayedSelectId = this.state.delayedSelectId;
        // if (delayedSelectId) {
        //     clearTimeout(delayedSelectId);
        // }

        global.removeEventListener("gesturestart", this.preventDefault);
        global.removeEventListener("gesturechange", this.preventDefault);
        global.removeEventListener("gestureend", this.preventDefault);

        global.removeEventListener("resize", this.updateDimensions);
        global.removeEventListener('orientationchange', this.updateDimensions);
        global.removeEventListener('contextmenu', this.handleRightClick, false);

        for (var i=0, l=events.length; i<l; i++) {
            const event = events[i];

            let source;
            let handler = this.handleTouchUpdate;

            // if ((event == 'pointermove') 
            //     || (event == 'mousemove')
            //     || (event== 'touchmove')
            //     || (event == 'gesturechange')
            // ) {
            //     handler = this.handleTouchUpdate;
            // } else {
            //     handler = this.handleTouchUpdate;
            // }

            if ((event == 'pointerdown') 
                || (event == 'mousedown')
                || (event == 'touchstart')
                // || (event == 'gesturestart')
            ) {
                source = this.domRef.current.parentNode;
            } else {
                source = global;
            }

            source.removeEventListener(event, handler);
        }

        for (var i=0, l=gestureEvents.length; i<l; i++) {
            if ((gestureEvents[i] == 'pointermove') || (gestureEvents[i] == 'mousemove')||(gestureEvents[i] == 'touchmove')||(gestureEvents[i] == 'gesturechange')) {
                this.domRef.current.parentNode.removeEventListener(gestureEvents[i],  this.handleTouchUpdate);
            } else {
                this.domRef.current.parentNode.removeEventListener(gestureEvents[i], this.handleTouchUpdate);
            }
        }

        this.domRef.current.parentNode.removeEventListener('wheel', this.handleMouseWheel);
    }

    shouldComponentUpdate() {
        return false;
    }

    emit(type, detail) {
        this.eventTarget.dispatchEvent(new CustomEvent(type, {detail}));
    }

    handleTouchUpdate(e) {
        // console.log(e.type);
        let x, y;

        switch(e.type) {
            case 'pointerdown': {
                // this.domRef.current.parentNode.setPointerCapture(e.pointerId)
                this.handlePointerDown(e)
                break;
            }
            case 'pointerup': {
                // console.log('pointerup', e)
                this.handlePointerUp(e)
                break;
            }
            case 'pointermove': {
                this.handlePointerMove(e)
                break;
            }    
            case 'pointercancel':
            {
                // console.log('pointercancel', e)
                this.handlePointerCancel(e)
                break;
            }

            // case 'mouseup': {
            //     console.log('mouseup', e);
            //     if (e.relatedTarget==null) {
            //         this.handlePointerCancel(e)
            //     }
            // }          
            
            case 'gesturestart':
                console.log('****', e.type, e.scale);
                e.preventDefault();

                this.emit('gesture-started(drag)', 
                null
                // {
                    //     start: clonePropsDeep(this.start),
                    //     current: clonePropsDeep(this.current),
                    //     gestureStartTarget: e.target,
                    //     type: 'drag',
                    //     delta: {
                    //         pos: {
                    //             x: 0,
                    //             y: 0
                    //         }
                    //     },
                    //     touchCount: 2,
                    //     coreTouchCount: 2
                    // }
                );
                break;
            case 'gesturechange':
                // console.log((new Date()).getMilliseconds())
                e.preventDefault();
                // console.log('****', e, e.clientX, e.clientY, e.pageX, e.pageY);
                let delta = 0;

                let offsetX = 0;
                let offsetY = 0;
                
                const frame = window.frameElement;//findUpTagByType(e.target, 'iframe');



                // console.log(e.target, frame);
                if (frame) {
                    // console.log('in frame:', frame, frame.parent, frame.document == window.document);
                    const frameBounds = frame.getBoundingClientRect();
                    offsetX = -frameBounds.left;
                    offsetY = -frameBounds.top;
                }

                x = e.clientX + offsetX;
                y = e.clientY + offsetY;

                this.emit('zoom-by', {
                    x,
                    y,
                    dz: e.scale,
                    pinnedToStart: true
                });
                break;

            case 'gestureend':
                x = e.clientX;
                y = e.clientY;
                this.emit(`gesture-ended`, {
                    x, y
                });

            default: {

            }
        }

    }

    handlePointerDown(e) {
        // e.preventDefault();
        // e.target.setPointerCapture(e.pointerId);

        if (e.button & 2) {
            //right-click
            console.log('disable right-click (pointer down)');
            e.preventDefault();
        }

        if (!this.activeGesture) {
            console.log("starting a new active gesture...")
            this.activeGesture = new Gesture.Processor(this.eventTarget);
        }
        this.handlePointerMove(e)
    }
    
    handlePointerUp(e) {
        // e.preventDefault()
        // console.log("PointerUp: ", e)
        // console.log("handlePointerUp: ", e);

        if (e.button & 2) {
            //right-click
            console.log('disable right-click (pointer up)');
            e.preventDefault();
        }

        if (this.activeGesture) {
            this.activeGesture.clearTouch(String(e.pointerId), e.timeStamp)
        }

    }
    
    handlePointerCancel(e) {
        // e.preventDefault()
        // console.log("PointerCancel: ", e.pointerId, e.type);
        if (this.activeGesture) {
            this.activeGesture.clearTouch(String(e.pointerId), e.timeStamp)
        }
    }
    
    handlePointerMove(e) {
        this.emit('move-pointer-to', {
            x: e.clientX,
            y: e.clientY
        });

        if (e.buttons === 0 && e.pointerType =='mouse') {
            // mouse moved with no buttons, or pen hovered without contact
            return
        }
        // e.preventDefault()

        let touch = Gesture.TouchDetail.fromBrowserPointerEvent(e)

        if (!this.activeGesture) {
            console.log("changed windows?")
            this.activeGesture = new Gesture.Processor(this.eventTarget);
        }

        // console.log(e.type, e.target
        //e.type == 'pointerdown' ? e.target : null
        this.activeGesture.setTouch(String(e.pointerId), touch, e.timeStamp, e.target);
    }

    handleRightClick(e) {
        console.log('disable right-click (context menu event)', e);
        e.preventDefault();
    }

    handleMouseWheel(e) {
        e.preventDefault();

        let x = e.clientX;
        let y = e.clientY;

        // hidePointer()
        // if (e.ctrlKey) {
        // console.log('this.props.currentTool', this.props.currentTool);
        if (e.ctrlKey || this.props.currentTool == 'PAN') {
            // pinch-zoom
            let delta = clamp(e.deltaY, -10, 10);
            // console.log(`WHEEL PINCH delta  ${e.deltaY}  clamped  ${delta}`)
            // this.emit('')
            // this.props.zoomBy(WHEEL_ZOOM_SENSITIVITY * delta)
            this.emit('zoom-by', {
                x,
                y,
                dz: WHEEL_ZOOM_SENSITIVITY * -1 * delta //  Math.sign(delta) *  Math.pow(Math.abs(delta), 1.4)
            });
        } else {
            // scroll-pan
            // this.props.panBy(
            //     -e.deltaX,
            //     -e.deltaY)

            this.emit('pan-by', {dx: -e.deltaX, dy: -e.deltaY});
        }
    }

    updateDimensions(e) {
        if (!this.domRef.current) {
            return;
        }
        
        const width = e && !this.domRef.current.parentNode.offsetWidth ? e.width : this.domRef.current.parentNode.offsetWidth;
        const height = e && !this.domRef.current.parentNode.offsetHeight ? e.height : this.domRef.current.parentNode.offsetHeight;

        this.props.setWorkspaceSize(
            width,
            height
        );
    }

    render() {
        return (
            <div
                className="PlatformEventInterface"
                ref={this.domRef}

                //need these for unit tests :/
                onPointerDown={e => this.handleTouchUpdate(e)}
                onPointerMove={e => this.handleTouchUpdate(e)}
                onPointerUp={e => this.handleTouchUpdate(e)}
            >
            </div>
        );
    }

    preventDefault(e) {
        e.preventDefault();
        // e.stopPropagation();
    }
}

const mapStateToProps = (state, ownProps) => {
    return Object.assign({}, {
        width: state.camera.size.width,
        height: state.camera.size.height,
        currentTool: state.tool.current
    }, ownProps);
}

PlatformEventInterface.displayName = "PlatformEventInterfaceComponent";
const connectedComponent = connect(
    mapStateToProps,
    {
        ...actions
    }
)(PlatformEventInterface);
connectedComponent.displayName = "PlatformEventInterface";


PlatformEventInterface.propTypes = {

};

export default connectedComponent;
export { PlatformEventInterface as PlatformEventInterfaceComponent };